// import { uiSlice } from '../redux/slices';
// import { store } from '../redux/store';

import { useToast } from '@orionprotocol/ui';

export const displayError = (errorMessage: string) => (error: unknown): void => {
  const { showToast } = useToast();

  const thrownError = error instanceof Error ? ` (${error.message})` : '';
  showToast({
    // iconType: 'error',
    text: errorMessage + thrownError,
  });
};
